<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>东交智慧物业公司正式起航，国企合作赋能城市服务</h2>
        <div id="meta_content">

          <span class="rich_b">
            东进防控
          </span>
          <span id="rich_c">
            <span>2025-02-25 19:11</span>
            广东
          </span>
        </div>
        <p>
          战鼓催征春来早，扬鞭奋蹄正当时！2025年开年来，东实集团紧扣市委市政府部署精神，落实省、市高质量发展大会要求，强化改革与科技动力，锚定“更市场、更专业、更高效”方向，以“开局即决战”姿态加速发展。本系列报道聚焦集团<span
            class="black"
          >一季度“开门红”攻坚实践</span>，解码各下属企业落实工作部署的硬核举措，透过镜头与笔触，见证东实人以实干、创新为城市高质量发展贡献力量。
        </p>
        <p>2月25日上午，<span
            class="black">东莞市东交智慧物业服务有限公司</span>（以下简称“东交智慧物业公司”）揭牌仪式在东莞迎宾馆顺利举行。
        </p>
        <p>
          东莞市国资委党委委员、副主任徐险峰；东莞交投集团党委书记、董事长刘波，党委副书记、总经理李斌峰，总经济师、东莞控股公司党委书记、董事长王崇恩；东实集团党委书记、董事长彭光顺，总裁王悦新，党委委员、副总裁莫松坚；东莞交通实业发展有限公司（以下简称“交通实业公司”）执行董事郝明军，广东东鸿物业发展有限公司（以下简称“东鸿物业公司”）执行董事、总经理朱雷及员工代表、媒体记者等70余人共同见证。
        </p>
        <img
          width="100%"
          :src="img[0]"
          alt=""
        >
        <p>
          东交智慧物业公司由东实集团旗下东鸿物业公司与东莞交投集团旗下交通实业公司合资成立，<span
            class="black">立足“物业+国企”业务合作新模式</span>，整合东鸿物业公司在公共物业服务领域的专业经验与交通实业公司在交通基础设施运营方面的资源优势，致力于为市民提供更智慧、更高效的城市服务，赋能城市高质量发展。
        </p>
        <p>
          彭光顺在致辞中表示，此次东鸿物业公司与交通实业公司合作成立东交智慧物业公司，既是贯彻市委市政府关于“支持东实集团打造综合性物业管理服务平台”决策部署的坚定行动，也是深化国资国企协同发展、整合资源优势、服务城市大局的创新尝试。此次双方强强联合、优势互补，必将为东莞物业服务市场注入新动能，为城市精细化管理和服务品质提升开辟新路径。他表示，希望合资公司股东双方团队<span
            class="black"
          >“坚持服务为民、强化创新驱动、注重协同发展”，以智慧化、专业化服务赋能城市品质提升，共同打造国企合作典范。</span>
        </p>
        <p>
          刘波在致辞中指出，交投集团与东实集团各有优势，两家国企强强联手，通过合作能取长补短，发挥各自的优势，共同在市场化竞争中获得一席之地。希望双方团队能够相互学习，将东实集团管理、经营和市场化体系等方面的先进理念和做法与交投集团的各项业务相结合，以市场化转型为契机，形成良好的合作模式，<span
            class="black"
          >打造一个管理团队强、经营能力优、市场化意识高，具备较强竞争力的企业，更好地服务市场需求，创造良好效益。</span>
        </p>
        <p>现场，徐险峰、刘波、彭光顺等共同为东交智慧物业公司成立揭牌，标志着这一国企合作平台正式扬帆起航。</p>
        <p>
          东交智慧物业公司的成立，是东莞国资国企响应市委市政府号召、推动城市服务升级的又一创新实践。未来，公司将以<span
            class="black"
          >“专业化、智慧化、协同化”</span>为核心，<span
            class="black">深耕物业服务领域，打造可复制的国企合作样板</span>，以高品质服务为市民美好生活与城市高质量发展赋能，书写国企服务城市、造福民生的新篇章！
        </p>
        <h3>我们还提供多元化服务</h3><img
          width="100%"
          :src="img[1]"
          alt=""
        >
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img
            :src="img[2]"
            alt=""
          >
        </div>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
        >
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News11' })"
          >东进公司道滘镇病媒生物...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>

      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news12.png'), require('@/assets/news8-4.png'), require('@/assets/news8-7.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
